export const PRODUCT_COLOR_PRESETS = [
  { name: 'Black', hex: '#000000' },
  { name: 'Matte Black', hex: '#2D2D2D' },
  { name: 'Gloss Black', hex: '#1A1A1A' },
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Red', hex: '#FF0000' },
  { name: 'Blue', hex: '#0066FF' },
  { name: 'Orange', hex: '#FF6600' },
  { name: 'Yellow', hex: '#FFD700' },
  { name: 'Green', hex: '#22C55E' },
  { name: 'Purple', hex: '#9B59B6' },
  { name: 'Grey', hex: '#808080' },
  { name: 'Brown', hex: '#8B4513' },
  { name: 'Beige', hex: '#F5F5DC' },
  { name: 'Maroon', hex: '#800000' },
  { name: 'Navy Blue', hex: '#001F3F' },
  { name: 'Sky Blue', hex: '#87CEEB' },
  { name: 'Teal', hex: '#008080' },
  { name: 'Neon Yellow', hex: '#FFFF00' },
  { name: 'Neon Green', hex: '#39FF14' },
  { name: 'Neon Pink', hex: '#FF10F0' },
  { name: 'Neon Orange', hex: '#FF5F1F' },
  { name: 'Neon Blue', hex: '#00FFFF' },
  { name: 'Neon Red', hex: '#FF073A' },
  { name: 'Neon Purple', hex: '#BC13FE' },
  { name: 'Pink', hex: '#FF69B4' },
  { name: 'Hot Pink', hex: '#FF1493' },
  { name: 'Silver', hex: '#C0C0C0' },
  { name: 'Gold', hex: '#FFD700' },
  { name: 'Carbon', hex: '#36454F' },
  { name: 'Metallic', hex: '#71797E' },
  { name: 'Camo Green', hex: '#4B5320' },
  { name: 'Chrome', hex: '#E8E8E8' },
  { name: 'Gunmetal', hex: '#2C3539' },
];

export const getProductColorHex = (colorName) => {
  const normalized = colorName?.trim().toLowerCase();
  const preset = PRODUCT_COLOR_PRESETS.find(
    (item) => item.name.toLowerCase() === normalized
  );
  if (preset) return preset.hex;
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(colorName?.trim() || '')) {
    return colorName.trim();
  }
  return '#333333';
};
